export const isValidObject = (data) => {
  return typeof data === "object" && data
    ? Object.keys(data).length > 0
    : false;
};

export const isValidArray = (data) => {
  return data && Array.isArray(data) && data.length > 0;
};
